import { Stack, StackProps, styled } from '@mui/material';
import { ReactNode } from 'react';

type CollapsingLayoutBlockProps = {
  open: boolean;
  children?: ReactNode;
} & StackProps;

const BlockContainer = styled(Stack, {
  name: 'CollapsingLayoutBlockContainer',
  shouldForwardProp: (prop) => prop !== 'open',
})<CollapsingLayoutBlockProps>(({ theme, open }) => ({
  flexShrink: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'padding'], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.standard,
  }),
  ...(open ? {} : { width: theme.utils.important(0) }),
}));

export const CollapsingLayoutBlock = (props: CollapsingLayoutBlockProps) => {
  const { children, ...rest } = props;
  return <BlockContainer {...rest}>{children}</BlockContainer>;
};
